
//various
const DEBUG = false;
const LAZYMODULES = true;
const ALERT = true;

const MODAL = true;
const COOKIEMODALMOCK = false; //you can use mock datas for develpment purpose, set FALSE for production
const COOKIEMODAL = true //you can disable cookies for development purpose, set TRUE for production

//animations
const ANIMATIONS = true;
const SCROLL = true;
const SCROLLREFRESH = true;
const PARALLAX = true;
const TYPOGRAPHY = false;
const FADEIN = true;
const BORDERS = true;
const FOOTER = true;

export {
  DEBUG,
  LAZYMODULES,
  ANIMATIONS,
  SCROLL,
  SCROLLREFRESH,
  PARALLAX,
  TYPOGRAPHY,
  FADEIN,
  BORDERS,
  FOOTER,
  ALERT,
  MODAL,
  COOKIEMODALMOCK,
  COOKIEMODAL,
};


